// The Terms-of-Service VERSION constants, alone in a file with no imports.
//
// ⚠️ Keep this file import-free. e2e/supabaseMock.ts seeds the mocked user's
// consents from TERMS_VERSION, and the ui-flow harness loads that mock with
// plain Node, which resolves relative paths but not the `@/` alias. When the
// mock imported terms.ts (which pulls in `@/lib/popia` and `@/lib/roles`), the
// harness could not start (shoot.test.mjs, PR #2248). popia.ts works for the
// same reason this file does: it imports nothing. terms.ts re-exports these,
// so app code keeps importing from '@/lib/terms'.

// Current terms version slug. Stored as a top-level key in users.consents
// when a user accepts. Bumping this forces every active user to re-accept.
export const TERMS_VERSION = 'terms_of_service_v1' as const

// Human-readable label, shown next to every acceptance tick-box and in the
// page header. Keep in lock-step with TERMS_VERSION.
//
// ⚠️ v1 is dated the day #2248 was merged (8 Oct 2026, SAST),
// not the day it was drafted (10 Sep): terms cannot be in force before they
// were published. If the merge lands on a later day, move BOTH constants to
// the merge date.
export const TERMS_VERSION_LABEL = 'v1, 8 October 2026' as const

// Effective date — the first day this version is in force.
export const TERMS_EFFECTIVE_DATE = '2026-10-08' as const
